import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import I18n from 'I18n';
import { GENERIC_CERT_DIMENSIONS } from '../../../constants/CourseConstants';
import { getMetadataLanguageFallback, useAchievementCertificateUrl, useAchievementTracks, usePublicAchievement } from '../achievementQueries';

const hrefBeforeSearch = ({
  origin,
  pathname
}) => `${origin}${pathname}`;

const removeAll = (container, selector) => {
  const els = container.querySelectorAll(selector);

  for (const el of els) {
    if (!el.parentNode) return;
    el.parentNode.removeChild(el);
  }
};

// See https://github.com/prerender/prerender#httpheaders
const DynamicHeadTags = ({
  head,
  publicId,
  wasFound,
  language
}) => {
  useEffect(() => {
    removeAll(head, '.override-with-translation');
  }, [head]);
  useEffect(() => {
    window.prerenderReady = true;
  }, []);
  const {
    publicAchievement
  } = usePublicAchievement(publicId);
  const image = useAchievementCertificateUrl(publicId);
  const tracks = useAchievementTracks(publicId);
  const {
    name: courseName
  } = tracks ? getMetadataLanguageFallback(tracks[0].metadata, language) : {
    name: null
  };
  return wasFound || !!publicAchievement ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("title", {
      children: I18n.text('academyPublic.certification.htmlTitle', {
        courseName
      })
    }), /*#__PURE__*/_jsx("meta", {
      content: I18n.text('academyPublic.certification.htmlTitle', {
        courseName
      }),
      property: "og:title"
    }), /*#__PURE__*/_jsx("meta", {
      content: I18n.text('academyPublic.certification.ogDescription', {
        courseName
      }),
      property: "og:description"
    }), /*#__PURE__*/_jsx("meta", {
      content: hrefBeforeSearch(window.location),
      property: "og:url"
    }), /*#__PURE__*/_jsx("meta", {
      content: image || undefined,
      property: "og:image"
    }), /*#__PURE__*/_jsx("meta", {
      content: GENERIC_CERT_DIMENSIONS.WIDTH.toString(),
      property: "og:image:width"
    }), /*#__PURE__*/_jsx("meta", {
      content: GENERIC_CERT_DIMENSIONS.HEIGHT.toString(),
      property: "og:image:height"
    }), /*#__PURE__*/_jsx("meta", {
      content: "website",
      property: "og:type"
    }), /*#__PURE__*/_jsx("meta", {
      content: "summary",
      name: "twitter:card"
    })]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("title", {
      children: I18n.text('academyPublic.certification.achievementNotFoundTitle')
    }), /*#__PURE__*/_jsx("meta", {
      content: "404",
      name: "prerender-status-code"
    })]
  });
};

const PrerenderGlobals = ({
  head,
  publicId,
  language,
  wasFound
}) => /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx(DynamicHeadTags, {
  head: head,
  language: language,
  publicId: publicId,
  wasFound: wasFound
}), head);

PrerenderGlobals.defaultProps = {
  head: document.head
};
export default PrerenderGlobals;